import BillingsOrderRelatedCargoRailyResponse, {
  BillingsOrderRelatedCargoRailyResponseDataCargoOrder,
  BillingsOrderRelatedCargoRailyResponseDataContractCargoCompany,
  BillingsOrderRelatedCargoRailyResponseDataContract,
  BillingsOrderRelatedCargoRailyResponseData,
} from "../../../../../api/raily/billings/order/related/cargo-raily/billings-order-related-cargo-raily.response";
import BillingsOrderRelatedCargoRaily, {
  BillingsOrderRelatedCargoRailyCargoOrder,
  BillingsOrderRelatedCargoRailyContract,
  BillingsOrderRelatedCargoRailyContractCargoCompany,
} from "./billings-order-related-cargo-raily";

const createCargoOrder = (
  cargoOrder: BillingsOrderRelatedCargoRailyResponseDataCargoOrder,
): BillingsOrderRelatedCargoRailyCargoOrder => {
  return {
    humanId: cargoOrder.humanId,
    uuid: cargoOrder.id,
  };
};

const createCargoCompany = (
  cargoCompany: BillingsOrderRelatedCargoRailyResponseDataContractCargoCompany,
): BillingsOrderRelatedCargoRailyContractCargoCompany => {
  return {
    companyName: cargoCompany.companyName,
  };
};

const createContract = (
  contract: BillingsOrderRelatedCargoRailyResponseDataContract,
): BillingsOrderRelatedCargoRailyContract => {
  return {
    cargoCompany: createCargoCompany(contract.cargoCompany),
    distanceRate: contract.distanceRate,
    model: contract.model,
  };
};

const createDataItem = (
  item: BillingsOrderRelatedCargoRailyResponseData,
): BillingsOrderRelatedCargoRaily => {
  return {
    cargoOrder: createCargoOrder(item.cargoOrder),
    contract: createContract(item.contract),
    date: item.date,
    discount: item.discount,
    discountAmount: item.discountAmount,
    distance: item.distance,
    haltingAmount: item.haltingAmount,
    highwayCharge: item.highwayCharge,
    totalAmount: item.totalAmount,
  };
};

const createData = (
  data: BillingsOrderRelatedCargoRailyResponseData[],
): BillingsOrderRelatedCargoRaily[] => {
  return data.map(createDataItem);
};

const create = (
  response: BillingsOrderRelatedCargoRailyResponse,
): BillingsOrderRelatedCargoRaily[] => {
  return createData(response.data);
};

const billingsOrderRelatedCargoRailyFactory = {
  create,
};

export default billingsOrderRelatedCargoRailyFactory;
